import { render } from "./RBtn.vue?vue&type=template&id=f9616478"
import script from "./RBtn.vue?vue&type=script&lang=js"
export * from "./RBtn.vue?vue&type=script&lang=js"

import "./RBtn.vue?vue&type=style&index=0&id=f9616478&lang=css"
script.render = render

export default script